import ApiConnection, { CommonDataConnection } from '@eway-crm/connector';
import { getBaseUrl } from '../api/legacyApi';

const serviceUrl = window.location.host === 'localhost:3000' ? 'http://localhost:3158/' : getBaseUrl();
export const apiConnection: ApiConnection = ApiConnection.createAnonymous(serviceUrl);
const commonDataConnection: CommonDataConnection = new CommonDataConnection(apiConnection, (error) => {
    console.error('Error with CommonDataConnection', error);
});

export default commonDataConnection;
